import { useController } from 'react-hook-form';
import { RadioList, RadioListVariantProps } from 'ui/radioList';
import { FieldProps } from './types';

type RadioListFieldProps = FieldProps & Omit<RadioListVariantProps, 'onSelect' | 'value'>;

export const RadioListField = ({ name, ...rest }: RadioListFieldProps) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    defaultValue: '',
  });

  return <RadioList {...rest} name={name} value={value} onSelect={onChange} />;
};
